<template>
    <b-form-group
            class="c-number"
            :description="description"
            :label="label"
            :label-for="id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
      <b-form-input
              v-if="required"
              type="number"
              :id="id"
              :state="chkState(id)"
              v-model="dataValue"
              :readonly="readOnly"
              :placeholder="placeholder"
              :autocomplete="autocomplete"></b-form-input>
        <b-form-input
                v-else
                type="number"
                :id="id"
                v-model="dataValue"
                :readonly="readOnly"
                :placeholder="placeholder"
                :autocomplete="autocomplete"></b-form-input>
      <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
        {{invalidFeedbackMessage}}
      </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
  export default {
      name: 'InputNumber',
      props: {
          required: {
              type: Boolean,
              default: false
          },
          value: {
              type: String | Number,
              default: ''
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          placeholder: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          autocomplete: {
              type: String,
              default: ''
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          readOnly: {
              type: Boolean,
              default: false
          },
          form: {
              type: Object,
              default: function() {return {}}
          }
      },
      watch: {
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
          }
      },
      mounted() {
          this.dataValue = this.value
      },
      data: () => {
          return {
              dataValue: ''
          }
      },
      methods: {
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          }
      }
  }
</script>